@if(is_loading){
<div>
  <div class="mt-6 pb-6 rounded-[10px] border border-[#D3DCE8B2]" style="margin-bottom: 220px">
    <div class="flex items-center flex-col justify-center gap-2">
      <ng-lottie [options]="animation" width="160px" height="160px" class="w-[160px] h-[160px]"></ng-lottie>
      <p class="m-0 text-[16px] font-medium text-[#898F9E]">One moment while we locate the suggested reminders for this template...</p>
    </div>
  </div>
</div>
}@else{
<div
  class="common__suggestion--view w-full mt-6 h-full"
  [ngStyle]="
    inlineComponent
      ? {
          display: 'flex',
          'flex-direction': 'column'
        }
      : {}
  "
>
  @if ((formatted_reminder_list | reminderSuggestionFilter : reminderList).length) {
  <div class="app__centered-item justify-between w-full">
    <p class="text-sm text-[#18191C] font-semibold">
      Suggestions<span class="text-[#25508e] font-bold ml-1">
        ({{ (formatted_reminder_list | reminderSuggestionFilter : reminderList).length }})
      </span>
    </p>
  </div>
  } @if ((formatted_reminder_list | reminderSuggestionFilter : reminderList).length) {
  <div
    [style.max-height]="!inlineComponent ? '136px' : 'auto'"
    [ngClass]="{ 'max-h-[60%] h-[60%]': !inlineComponent }"
    class="flex flex-wrap w-full overflow-y-auto gap-3"
  >
    @for (item of formatted_reminder_list | reminderSuggestionFilter :reminderList ; track item) {
    <ng-container>
      <span class="app__discovery--selected--option h-[66px] p-0 px-4 overflow-y-hidden" [ngStyle]="{ 'margin-right.px': inlineComponent ? 0 : 9 }">
        <img src="assets/images/reminder-suggestion-icon.svg" />
        <span class="w-[80%] app__form--attribute--title font-semibold text-sm text-[#515765]" matTooltipPosition="above">
          <p class="text-sm font-semibold mb-1">
            {{ item.object_config.display_text | reminderTitleName : formValue : item }}
          </p>
          @if(item.error_message){
          <p class="text-sm font-medium text-[#EB5757] mb-1">{{ item.error_message }}</p>
          }@else{
          <p class="text-[10px] text-[#707070] font-medium mb-1">
            {{ item.object_config.display_subtext | reminderTitleName : formValue : item }}
          </p>
          }
        </span>
        <div class="app__centered-item justify-end">
          <button
            [ngClass]="item.is_disable ? 'app__btn--disabled mt-0' : 'app__btn--primary mt-0'"
            (click)="addReminderWithSuggestion(item)"
            class="app__btn--primary sm:py-[6px] py-[6px] px-5 m-0 rounded-lg text-[12px]"
          >
            <span> Add </span>
          </button>
        </div>
      </span>
    </ng-container>
    }
  </div>
  }
  <!-- <button
    (click)="addReminder()"
    style="min-height: 48px; line-height: 48px; background-color: white; color: #25508e; border: 1px solid #25508e"
    class="app__btn--secondary mt-3 mb-3 p-0 hover:cursor-pointer ng-star-inserted"
  >
    Add Custom Reminder
  </button> -->
</div>

}
